(function($) {

  $('.block__two-columns__custom-extended').on('click', function(e) {
    e.preventDefault();

    var $this = $(this);
    $this.toggleClass('is-expanded');

    var columnsbottom = $this.find('.columns-bottom');
    columnsbottom.slideToggle({
      start: function () {
        $(this).css({
          display: "flex"
        })
      }
    });

  });

  $('.block__two-columns__custom-link').on('click', function(e) {
    e.preventDefault();

    var $this = $(this);
    var target = $this.attr('data-target');
    var url = $this.attr('data-url');

    window.open(url, target);
  });

})(jQuery);